import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import ReplyModal from "./balasAspirasi";
import SkeletonGridDetailAspirasi from "../../../Components/loading/detailSkeleton";
const DetailAspirasi = () => {
  const { id } = useParams(); // id = presiden_id
  const [aspirasiList, setAspirasiList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  // Filter status: "", "sudah", "belum"
  const [statusFilter, setStatusFilter] = useState("");

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAspirasiId, setSelectedAspirasiId] = useState<number | null>(null);

  const fetchAspirasi = async (page = 1, status = "") => {
    setLoading(true);
    try {
      const token = Cookies.get("token");
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aspirasi/presiden/${id}?page=${page}&per_page=${perPage}${status ? `&status=${status}` : ""}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAspirasiList(res.data.data || []);
      setCurrentPage(res.data.current_page);
      setLastPage(res.data.last_page);
      setPerPage(res.data.per_page);
    } catch (err) {
      console.error("Gagal fetch aspirasi:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAspirasi(currentPage, statusFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, currentPage, statusFilter]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatusFilter(e.target.value);
    setCurrentPage(1); // reset ke halaman pertama kalau ganti filter
  };

  const handleOpenModal = (aspirasiId: number) => {
    setSelectedAspirasiId(aspirasiId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedAspirasiId(null);
    setIsModalOpen(false);
  };

  if (loading)
    return (
      <div className="p-4">
        <SkeletonGridDetailAspirasi />
      </div>
    );

  return (
    <div className="p-6">
      <Link to="/dashboard/aspirasi" className="text-blue-600 mb-4 inline-block">
        ← Kembali
      </Link>
      <h1 className="text-2xl font-bold mb-6">Detail Aspirasi</h1>

      {/* Filter */}
      <div className="mb-4">
        <label className="mr-2 font-semibold">Filter Status:</label>
        <select value={statusFilter} onChange={handleFilterChange} className="border rounded px-2 py-1">
          <option value="">Semua</option>
          <option value="sudah">Sudah Dijawab</option>
          <option value="belum">Belum Dijawab</option>
        </select>
      </div>

      {aspirasiList.length === 0 ? (
        <div className="text-gray-500">Belum ada aspirasi untuk pejabat ini.</div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {aspirasiList.map((item) => (
            <div key={item.id} className="border rounded-lg shadow-md p-4 bg-white">
              <h2 className="text-lg font-bold mb-2">{item.judul}</h2>
              <p className="text-gray-700 mb-1">
                <span className="font-semibold">Pengirim:</span> {item.user?.name || item.nama}
              </p>
              <p className="text-gray-700 mb-1">
                <span className="font-semibold">Tanggal:</span>{" "}
                {new Date(item.created_at).toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
              <p className="text-gray-700 mb-3">
                <span className="font-semibold">Deskripsi:</span> {item.deskripsi}
              </p>

              {item.balasan ? (
                <p className="text-green-700 bg-green-100 px-3 py-2 rounded">
                  <span className="font-semibold">Balasan:</span> {item.balasan}
                </p>
              ) : (
                <div className="flex justify-start">
                  <button onClick={() => handleOpenModal(item.id)} className="text-white font-bold px-3 py-2 rounded bg-red-600 hover:bg-red-700">
                    Balas Aspirasi Ini!
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Pagination controls */}
      <div className="flex justify-end gap-4 items-center mt-6">
        <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="px-4 py-2 bg-black2 text-white rounded disabled:opacity-50">
          Prev
        </button>
        <div className="border border-black2 rounded px-4 py-2">
          Page {currentPage} dari {lastPage}
        </div>
        <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, lastPage))} disabled={currentPage === lastPage} className="px-4 py-2 bg-black2 text-white rounded disabled:opacity-50">
          Next
        </button>
      </div>

      {/* Modal Balasan */}
      <ReplyModal isOpen={isModalOpen} onClose={handleCloseModal} aspirasiId={selectedAspirasiId} onSuccess={() => fetchAspirasi(currentPage, statusFilter)} />
    </div>
  );
};

export default DetailAspirasi;
